<template>
  <div ref="contenedorCollage" class="collage-carousel">
    <div ref="bgRef" class="bg-rosa"></div>

    <img src="@/assets/fl.png" class="flor flor-lt" alt="" />
    <img src="@/assets/fl.png" class="flor flor-rb" alt="" />

    <div class="collage-grid">
      <div
        v-for="(image, index) in images"
        :key="index"
        :ref="el => { if (el) listaFotos[index] = el }"
        class="collage-item"
        @click="enlargeImage(index)"
      >
        <img
          :src="image"
          class="collage-image"
          :alt="'Imagen ' + index"
        />
      </div>
    </div>

    <div
      v-if="isImageEnlarged"
      class="image-modal"
      @click="closeModal"
    >
      <img
        :src="images[currentIndex]"
        class="enlarged-image"
        alt="Imagen ampliada"
      />
    </div>

    <div class="rasgado rasgado-inferior"></div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CollageAnimadoMagico',
  setup() {
    const images = [
      require('@/assets/M9.webp'),
      require('@/assets/M10.webp'),
      require('@/assets/M7.webp'),
      require('@/assets/M8.webp'),
      require('@/assets/M12.webp'),

     
    ]

    // Refs de control local aisladas
    const contenedorCollage = ref(null)
    const bgRef = ref(null)
    const listaFotos = ref([]) // Sustituye al antiguo collageItems corrupto

    const currentIndex = ref(0)
    const isImageEnlarged = ref(false)
    
    let observadorVisible = null
    let ctxGsap = null

    const enlargeImage = (index) => {
      currentIndex.value = index
      isImageEnlarged.value = true
    }

    const closeModal = () => {
      isImageEnlarged.value = false
    }

    onMounted(async () => {
      await nextTick()
      if (!contenedorCollage.value) return

      // Selector scoped exclusivo para este componente
      const $ = gsap.utils.selector(contenedorCollage.value)
      const flores = $('.flor')

      // Limpiamos slots vacíos del array de fotos por seguridad
      const fotosFiltradas = listaFotos.value.filter(Boolean)

      // Estados iniciales estrictos e individuales (Evitamos ocultar el contenedor padre)
      gsap.set(bgRef.value, { opacity: 0 })
      gsap.set(flores, { opacity: 0, scale: 0.85, y: 20 })
      gsap.set(fotosFiltradas, { opacity: 0, y: 35 })

      // IntersectionObserver optimizado para el Viewport móvil
      observadorVisible = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return

          // Encapsulamos en contexto para blindar las animaciones
          ctxGsap = gsap.context(() => {
            const tl = gsap.timeline({ 
              defaults: { 
                ease: 'power3.out',
                lazy: false // Sincronización inmediata de renderizado en iOS/Android
              } 
            })

            // 1. Entrada suave del fondo
            tl.to(bgRef.value, {
              opacity: 1,
              duration: 0.5
            })

            // 2. Revelado elegante de las flores ornamentales
            .to(flores, {
              opacity: 0.55,
              scale: 1,
              y: 0,
              duration: 0.6,
              stagger: 0.12
            }, '-=0.3')

            // 3. 🔥 ENTRADA CINEMATOGRÁFICA DE LAS FOTOS (Garantizado)
            .to(fotosFiltradas, {
              opacity: 1,
              y: 0,
              duration: 0.7,
              stagger: 0.15 // Efecto cascada premium al ir bajando
            }, '-=0.4')

            // Bucle infinito orgánico de flotación para las flores decorativas
            flores.forEach((flor, i) => {
              gsap.to(flor, {
                y: `+=${gsap.utils.random(8, 14)}`,
                rotate: gsap.utils.random(-5, 5),
                duration: gsap.utils.random(3.5, 4.5),
                repeat: -1,
                yoyo: true,
                ease: 'sine.inOut',
                delay: i * 0.2
              })
            })

          }, contenedorCollage.value)

          // Desconectamos para que la animación de entrada se ejecute de manera perfecta una sola vez
          observadorVisible.disconnect()
        })
      }, { 
        threshold: 0.15, // Se activa en cuanto asoma el 15% del contenedor en el móvil
        rootMargin: "0px 0px -5% 0px" 
      })

      observadorVisible.observe(contenedorCollage.value)
    })

    onUnmounted(() => {
      if (observadorVisible) observadorVisible.disconnect()
      if (ctxGsap) ctxGsap.revert()
    })

    return {
      images,
      contenedorCollage,
      bgRef,
      listaFotos,
      currentIndex,
      isImageEnlarged,
      enlargeImage,
      closeModal
    }
  }
}
</script>

<style scoped>
.collage-carousel {
  position: relative;
  width: 100%;
  min-height: 70vh;
  margin-bottom: -40px;
  overflow: visible;
}

/* FONDO ROSA */
.bg-rosa {
  position: absolute;
  inset: 0;
   background:
    linear-gradient(
       rgba(18, 5, 50, 0.941),
      rgb(61, 46, 85)
    ),
    url('@/assets/fn.avif') center center / cover no-repeat;
  z-index: 0;
}

/* 🌸 FLORES */
.flor {
  position: absolute;
  width: 120px;
  max-width: 45vw;
  opacity: 0;
  pointer-events: none;
  z-index: 1;
}

.flor-lt { top: 0vh; left: -45px; }
.flor-lb { bottom: 6vh; left: -55px; }
.flor-rt { top: 0vh; right: -45px; }
.flor-rb { bottom: 9vh; right: -55px; }

/* GRID */
.collage-grid {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  padding-top: 6vh;
  padding-bottom: 6vh;
}

.collage-item {
  grid-column: span 12;
  opacity: 0; /* Controlado estrictamente por GSAP */
  cursor: pointer;
  margin-bottom: 10vh;
  display: flex;
  justify-content: center;
}

.collage-image {
  width: 90%;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
  transition: transform 0.3s ease;
}

.collage-image:hover {
  transform: scale(1.03);
}

/* MODAL */
.image-modal {
  position: fixed;
  inset: 0;
  background: rgba(10, 10, 10, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.enlarged-image {
  max-width: 90%;
  max-height: 90%;
  border-radius: 12px;
}

/* ===== Rasgados ===== */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 50px;
  background: #fff;
    overflow: visible;

  z-index: 12;
  pointer-events: none;
}

.rasgado-inferior {
  bottom: 0;
   background:
    linear-gradient(
     rgba(18, 5, 50, 0.941),
      rgb(61, 46, 85)
    ),
    url('@/assets/bn.avif') center center / cover no-repeat;
  clip-path: polygon(
    0% 80%,
    25% 60%,
    50% 85%,
    75% 55%,
    100% 75%,
    100% 0%,
    0% 0%
  );
}
</style>